import { GalleryButton } from '@/components/common/Gallery/styles';
import Icon from '@/units/Icon';
import { ArrowDirection, ArrowProps } from '@/components/common/Gallery/types';
import { FC } from 'react';

export const Arrow: FC<ArrowProps> = ({ className, style, onClick, direction }) => {
  return (
    <GalleryButton className={className} style={{ ...style, margin: '50px' }} onClick={onClick}>
      {direction === ArrowDirection.Left && <Icon.ChevronLeft style={{ color: 'white' }} />}
      {direction === ArrowDirection.Right && <Icon.ChevronRight style={{ color: 'white' }} />}
    </GalleryButton>
  );
};
